import { SessionOccurrence } from "../models/SessionOccurrence";
import { OccurrenceStatus } from "../models/OccurrenceStatus";

/** Today's date in the browser's local zone, as YYYY-MM-DD. */
export function localToday(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

const activeOnly = (occurrences: SessionOccurrence[]): SessionOccurrence[] =>
  occurrences.filter((o) => o.status !== OccurrenceStatus.Cancelled);

/**
 * The occurrence date an instructor most likely wants to mark attendance for:
 * the most recent occurrence up to and including today, else the first upcoming
 * one. Undefined while no occurrences are known.
 */
export function defaultAttendanceDate(
  occurrences: SessionOccurrence[],
  today: string = localToday()
): string | undefined {
  const active = activeOnly(occurrences);
  if (active.length === 0) return undefined;
  const pastOrToday = active.filter((o) => o.effectiveDate <= today);
  return pastOrToday.length > 0
    ? pastOrToday[pastOrToday.length - 1].effectiveDate
    : active[0].effectiveDate;
}

/** The next upcoming (non-cancelled) occurrence date, if any. */
export function nextOccurrenceDate(
  occurrences: SessionOccurrence[],
  today: string = localToday()
): string | undefined {
  return activeOnly(occurrences).find((o) => o.effectiveDate >= today)?.effectiveDate;
}
